module.exports = __webpack_public_path__ + "img/chouqian-rim.0951ea39.png";